import { connect } from 'react-redux';

import { selectBuilderInfo, selectIsNewbuildingPremiumRate } from '../../selectors/newbuildingPremiumRate';
import { IState } from '../../store';
import { isCountrysideCardIntegrated } from '../../utils/countrysideCardIntegration';
import { IMainProps, Main } from './index';

export function mapStateToProps(state: IState): IMainProps {
  const isNewbuildingPremiumRateEnabled = selectIsNewbuildingPremiumRate(state);

  return {
    offer: state.offerData.offer,
    user: state.offerData.user,
    isOpenCommentBlock: state.commentsData.isOpen,
    isCountrysideCardIntegrated: isCountrysideCardIntegrated(state),
    isNewbuildingBannerEnabled: !isNewbuildingPremiumRateEnabled,
    builderInfo: isNewbuildingPremiumRateEnabled ? selectBuilderInfo(state) : null,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MainContainer = connect<IMainProps, any, any>(mapStateToProps)(Main);
